import { Column, Entity, JoinColumn, ManyToOne, OneToMany } from "typeorm";
import { CxAnswer } from "./cx-answer.entity";
import { CommonColumns } from "./common-columns.entity";
import { CxQuestionHeader } from "./cx-question-header.entity";
import { CxShopToken } from "./cx-shop-token.entity";
// CxShopの代わりにBranchesを用いる
// import { CxShop } from "./cx-shop.entity";
import { Branches } from "./branches.entity";

export enum AnswerMode {
  TEST = 'test',
  NORMAL = 'normal',
}

@Entity()
export class CxAnswerHeader extends CommonColumns {

  // 誤って回答結果がQuestionHeaderにくっついてクライアント側に送信されると大問題になる
  // 敢えて逆側の参照は持たせない
  // @ManyToOne(() => CxShop, { nullable: false, })
  // @JoinColumn({ name: 'cx_shop_id', referencedColumnName: 'id', })
  // cxShop?: CxShop;

  // @Column({ name: 'cx_shop_id', })
  // cx_shopId: number;
  // CxShopの代わりにBranchesを用いる
  @ManyToOne(() => Branches, { nullable: false, })
  @JoinColumn({ name: 'branch_id', referencedColumnName: 'id', })
  branch?: Branches;

  @Column({ name: 'branch_id', })
  branchId: number;


  // 誤って回答結果がQuestionHeaderにくっついてクライアント側に送信されると大問題になる
  // 敢えて逆側の参照は持たせない
  @ManyToOne(() => CxQuestionHeader, { nullable: false, })
  @JoinColumn({ name: 'cx_question_header_id', referencedColumnName: 'id', })
  cxQuestionHeader?: CxQuestionHeader;

  @Column({ name: 'cx_question_header_id', })
  cxQuestionHeaderId: number;

  @ManyToOne(() => CxShopToken, { nullable: false, })
  @JoinColumn({ name: 'cx_shop_token_id', referencedColumnName: 'id', })
  cxShopToken?: CxShopToken;

  @Column({ name: 'cx_shop_token_id', })
  cxShopTokenId: number;

  @Column({
    name: 'answer_mode',
    enum: AnswerMode,
    default: AnswerMode.NORMAL,
  })
  answerMode: AnswerMode;

  @Column({ name: 'read_at', type: 'timestamptz', })
  readAt: Date;
  
  @Column({ name: 'answered_at', type: 'timestamptz', nullable: true, })
  answeredAt: Date|null;

  @Column({ name: 'flagged', })
  flagged: boolean;
  
  @Column({ name: 'watched', })
  watched: boolean;
  
  @Column({ name: 'shared', })
  shared: boolean;
  
  @Column({ name: 'todoed', })
  todoed: boolean;
  
  @Column({ name: 'todo_completed', })
  todoCompleted: boolean;

  @Column({ name: 'todo_completed_by', })
  todoCompletedBy: string;

  @Column({ name: 'student_todo_id', type: 'integer', nullable: true, })
  studentTodoId: number|null;

  @OneToMany(() => CxAnswer, cxAnswer => cxAnswer.cxAnswerHeader)
  cxAnswers: CxAnswer[];

  constructor(props: TCxAnswerHeader) {
    super();
    Object.assign(this, props);
  }
}

export declare type TCxAnswerHeader = Omit<CxAnswerHeader, 'dummy-no-such-field'>;
export interface ICxAnswerHeader extends TCxAnswerHeader {};
